import React, { Fragment } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import Footer from '../Footer';

const useStyles = makeStyles(() => {
  return {
    container: {
      flex: '1 0 auto'
    }
  };
});
interface ContainerWithFooterProps {
  children: React.ReactNode;
}

const ContainerWithFooter: React.FC<ContainerWithFooterProps> = ({ children }) => {
  const styles = useStyles();
  return (
    <Fragment>
      <div className={styles.container}>{children}</div>
      <Footer />
    </Fragment>
  );
};

export default ContainerWithFooter;
